import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessListCustomEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-list-custom-embed',
	path: '/jira/core/projects/:projectKey/list/:navigationItemId/embed',
	exact: true,
};
